import { Survey } from './survey';
import { Page } from './page';
import { Question } from './question';

export class Choice {
  id: number;
  text: string;
  text_pretty: string;
  value: string;
  order: number;
  is_other: boolean;
  is_bold: boolean;
  is_separator: boolean;
  subtext: string;
  subtext_pretty: string;
  other_choice_text_field: string;
  question_id: number;
  page_id: number;
  survey_id: number;

  private _survey: Survey;

  getSurvey(): Survey {
    return this._survey;
  }

  setSurvey(survey: Survey) {
    this._survey = survey;
  }

  private _page: Page;

  getPage(): Page {
    return this._page;
  }

  setPage(page: Page) {
    this._page = page;
  }

  private _question: Question;

  getQuestion(): Question {
    return this._question;
  }

  setQuestion(question: Question) {
    this._question = question;
  }

  toJSON(): Object {
    // create an instance of the Choice class
    let choice = Object.create(Choice.prototype);
    // copy all the fields to the json object
    choice.text = this.text;
    choice.value = this.value;

    return choice;
  }

  static fromJSON(choice_json: Object): Choice {
    // create an instance of the Choice class
    let choice = Object.create(Choice.prototype);
    // copy all the fields from the json object
    let obj = Object.assign(choice, choice_json, {
      // convert fields that need converting
      // created: new Date(json.created),
    });

    return choice;
  }

}
